// extracted by mini-css-extract-plugin
export default {"TeamInfo":"TeamInfo_TeamInfo__bWKqn","Heading":"TeamInfo_Heading__7v7Ai","TeamPara":"TeamInfo_TeamPara__-Wa87"};